import {isFeatureEnabled} from '@github-ui/feature-flags'
import getFetchNonce from '@github-ui/fetch-nonce'
import {ssrSafeWindow} from '@github-ui/ssr-utils'
import {sendStats} from '@github-ui/stats'

const globalFetch = fetch

export default function applyFetchPatch() {
  if (ssrSafeWindow) {
    ssrSafeWindow.fetch = async (input: string | URL | Request, init?: RequestInit) => {
      try {
        const response = await customFetch(input, init)
        sendFetchStats({input, error: !response.ok, status: response.status})
        return response
      } catch (error) {
        sendFetchStats({input, error: true, status: 'unknown'})
        throw error
      }
    }
  }
}

function sendFetchStats({
  input,
  error,
  status,
}: {
  input: string | URL | Request
  error: boolean
  status: number | string
}) {
  if (!error) return

  const url = input instanceof Request ? input.url : input.toString()
  sendStats(
    {
      incrementKey: 'FETCH_ERROR',
      requestUrl: window.location.href,
      referredRequestUrl: url,
      incrementTags: {
        status: String(status),
      },
    },
    false,
    1,
  )
}

function customFetch(input: string | URL | Request, init: RequestInit | undefined) {
  if (shouldPatchFetch(input)) {
    return fetchWithNonce(input, init)
  }

  return globalFetch(input, init)
}

function shouldPatchFetch(input: string | URL | Request) {
  if (!isFeatureEnabled('fetch_patch')) return false

  let url: URL
  if (input instanceof Request) {
    url = new URL(input.url, window.location.origin)
  } else if (input instanceof URL) {
    url = input
  } else {
    url = new URL(input.toString(), window.location.origin)
  }

  return url.origin === window.location.origin
}

function fetchWithNonce(input: string | URL | Request, init: RequestInit | undefined) {
  const nonce = getFetchNonce()
  if (input instanceof Request) {
    input.headers.set('X-Fetch-Nonce', nonce)
    return globalFetch(input, init)
  }

  if (!init) {
    return globalFetch(input, {
      headers: {
        'X-Fetch-Nonce': nonce,
      },
    })
  }

  const newHeaders = new Headers(init.headers)
  newHeaders.set('X-Fetch-Nonce', nonce)
  init.headers = newHeaders

  return globalFetch(input, init)
}
